import { Transition } from '@headlessui/react'
import cx from 'classnames'
import type { ComponentProps, PropsWithChildren } from 'react'

import { paperStyles } from '../../libs/paperStyles'
import { typographyStyles } from '../../structure/typography/styles'
import type { useTooltip } from './useTooltip'

type UseTooltip = typeof useTooltip
type Props = PropsWithChildren<
  Pick<NonNullable<Parameters<typeof useTooltip>[0]>, 'placement'> &
    Pick<ReturnType<UseTooltip>, 'isOpen'> & {
      tipClassName?: string
    } & Pick<ComponentProps<'div'>, 'onMouseLeave' | 'ref'>
>

export const TooltipPaper = ({
  children,
  isOpen,
  placement,
  tipClassName,
  ...rest
}: Props) => (
  <Transition
    as="div"
    data-amaze-tooltip-paper
    {...rest}
    show={isOpen}
    appear
    enter="transition duration-200 ease-out"
    enterFrom="opacity-0 data-[amaze-placement^=bottom]:-translate-y-1 data-[amaze-placement^=top]:translate-y-1 data-[amaze-placement^=left]:translate-x-1 data-[amaze-placement^=right]:-translate-x-1"
    enterTo="opacity-100 translate-y-0 translate-x-0"
    data-amaze-placement={placement}
    className={cx(
      'p-1.5 flex rounded-lg shadow-lg overflow-auto',
      // The tip keeps within the room its positioning found for it, falling
      // back to the screen for as long as it has not been placed yet.
      'max-w-(--amaze-tooltip-available-width,calc(100dvw-var(--spacing)*6))',
      'max-h-(--amaze-tooltip-available-height,calc(100dvh-var(--spacing)*6))',
      paperStyles({ borders: ['all'] }),
      typographyStyles({ size: 'sm', intensity: 'secondary' }),
      tipClassName,
    )}
  >
    {children}
  </Transition>
)
